export default {
  path: 'fruit-machine',
  name: 'fruitMachine',
  component: () => import('@/views/fruit-machine/index.vue'),
  meta: {
    locale: '水果机',
    requiresAuth: true,
    icon: 'icon-apps',
    roles: ['super', 'admin'],
  },
  children: [
    {
      path: 'list',
      name: 'fruitMachineList',
      component: () => import('@/views/fruit-machine/list/index.vue'),
      meta: { locale: '水果机管理', requiresAuth: true, roles: ['super', 'admin'] },
    },
    {
      path: 'logs',
      name: 'fruitMachineLogs',
      component: () => import('@/views/fruit-machine/logs/index.vue'),
      meta: { locale: '抽奖记录', requiresAuth: true, roles: ['super', 'admin'] },
    },
  ],
};
